/**
 * supabase.ts — mango-web
 * PURPOSE: Initialize Supabase client for auth and API token retrieval.
 * Mirrors Android's SupabaseAuthClient — exposes the same auth methods
 * (signIn, signUp, signOut, resetPassword, signInWithMagicLink, OAuth).
 */

import { createClient } from '@supabase/supabase-js';

// --- Config ---

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('[Supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

// --- Client ---

export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  }
);

// --- Related Files ---
// CONNECTED TO:
//   - src/stores/authStore.ts — wraps this client for React state
//   - src/api/client.ts — uses getSession() for JWT injection
// USED BY:
//   - src/stores/authStore.ts
//   - src/routes/auth/Login.tsx
//   - src/routes/auth/Signup.tsx
